<sm-toolbar>
    <p-button severity="success" icon="fas fa-save" label="Speichern" (onClick)="saveInternal()">
    </p-button>
    <p-button severity="secondary" icon="fas fa-times" label="Abbrechen" (onClick)="cancel()">
    </p-button>
</sm-toolbar>
<div class="form-container">
    <p-card>
        <sm-form [form]="form">
        </sm-form>
    </p-card>
</div>
